import AuthUser from "components/auth";
import ErrorBoundary from "components/errorHandler";
import "config/firebase.config";
import "katex/dist/katex.min.css";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "store";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./translation";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <AuthUser>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthUser>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
